<template>
    <svg
        class="od-icon"
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
    >
        <template v-if="name === 'chevron-down'">
            <path d="m6 9 6 6 6-6" />
        </template>
        <template v-else-if="name === 'copy'">
            <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
            <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
        </template>
        <template v-else-if="name === 'check'">
            <path d="M20 6 9 17l-5-5" />
        </template>
        <template v-else-if="name === 'shopping-cart'">
            <circle cx="8" cy="21" r="1" />
            <circle cx="19" cy="21" r="1" />
            <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
        </template>
        <template v-else-if="name === 'external-link'">
            <path d="M15 3h6v6" />
            <path d="M10 14 21 3" />
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
        </template>
    </svg>
</template>

<script>
/** Lucide glyphs used by the Lovable mockup, inlined so the island keeps exact icon metrics. */
export default {
    name: 'OdIcon',
    props: {
        name: { type: String, required: true },
        size: { type: Number, default: 14 },
    },
};
</script>
